import { moment } from "../date";
import type { AssignmentReferenceSingleBookingSchema } from "../schemas";
import { generateId } from "../strings";
import { getDefaultBookingAdjustment } from "./get-default-booking-adjustment";

export function getDefaultBookings(date: string) {
	const initialId = generateId();
	const initialCheckIn = moment(date).hour(7).minute(0).postgresTimestamp();
	const initialCheckOut = moment(date).hour(17).minute(0).postgresTimestamp();
	const booking: AssignmentReferenceSingleBookingSchema = {
		id: initialId,
		userId: null,
		checkIn: initialCheckIn,
		checkOut: initialCheckOut,
		pause: 1,
		ranking: 0,
		note: null,
		adjustment: null,
	};
	booking.adjustment = getDefaultBookingAdjustment(booking);
	return {
		bookings: [booking],
	};
}
